import {
  faAngleRight,
  faLink,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faGithub,
  faLinkedin,
  faTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import AnchorButton from "../AnchorButton";
import Icon from "../../components/Icon";
import ProfileImage from "../ProfileImage";
import React from "react";
import SocialIcon from "../../components/SocialIcon";

export interface ProfileBannerProps {
  image?: string;
  title: string;
  firstname: string;
  lastname: string;
  position: string;
  institute: string;
  link: string;
  city?: string;
  country?: string;
  email: string;
  social?: {
    facebook?: string;
    twitter?: string;
    linkedin?: string;
    youtube?: string;
    github?: string;
    website?: string;
  };
}

const ProfileBanner = ({
  image,
  title,
  firstname,
  lastname,
  position,
  institute,
  city,
  country,
  link,
  email,
  social,
}: ProfileBannerProps) => {
  return (
    <div className="flex flex-wrap px-12 py-8 my-8 bg-gray-100 md:flex-no-wrap">
      <div className="w-6/12 p-4 lg:w-4/12">
        <div className="flex items-center justify-center w-full h-full">
          <ProfileImage src={image} />
        </div>
      </div>
      <div className="flex items-center justify-center w-full p-4">
        <div className="w-full">
          <div className="text-3xl font-medium leading-tight">
            {title} {firstname} {lastname}
          </div>
          <div className="mt-4">
            <div className="font-medium text-gray-400 text-md">
              {position}
              <br />
              {institute}
            </div>
          </div>
          {city && country ? (
            <div className="mt-4">
              <div className="text-xs text-gray-400">
                <Icon icon={faMapMarkerAlt} /> {city} {country}
              </div>
            </div>
          ) : null}
          <div className="mt-4">
            <div className="flex items-center justify-start">
              {social?.facebook && (
                <SocialIcon
                  href={social.facebook}
                  color="#2A448D"
                  icon={faFacebookF}
                />
              )}
              {social?.twitter && (
                <SocialIcon
                  href={social.twitter}
                  color="#57C5F6"
                  icon={faTwitter}
                />
              )}
              {social?.linkedin && (
                <SocialIcon
                  href={social.linkedin}
                  color="#3E7FBB"
                  icon={faLinkedin}
                />
              )}
              {social?.youtube && (
                <SocialIcon
                  href={social.youtube}
                  color="#CF2A16"
                  icon={faYoutube}
                />
              )}
              {social?.github && (
                <SocialIcon
                  href={social.github}
                  color="#24292E"
                  icon={faGithub}
                />
              )}
              {social?.website && (
                <SocialIcon
                  href={social.website}
                  color="#A4A4A4"
                  icon={faLink}
                />
              )}
            </div>
            <div className="mt-4">
              <a className="text-sm underline text-aqua" href={link}>
                View Profile <Icon icon={faAngleRight} />
              </a>
            </div>
          </div>
        </div>
      </div>
      {email ? (
        <div className="flex items-end justify-end p-4">
          <div className="w-full">
            <AnchorButton href={`mailto:${email}`}>Send Email</AnchorButton>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ProfileBanner;
